import { call, put, takeLatest } from "redux-saga/effects";
import {
  downloadSuccess,
  downloadFailure,
  userTypes,
  fetchUserSuccess,
  fetchUserError,
  fetchUserListSuccess,
  fetchUserListError,
  fetchRolesListSuccess,
  fetchRolesListFailure,
} from "../actions/user";
import { fetchUserEndPoint } from "../../configuration";
import { getRandomUUID } from "../../Token";
import { setIsLoading } from "../actions/alertsGroup";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
import { obscureText, obscureEmail } from "../../global/utility/obscureString";
import { fetchRoles } from "../../global/utility/Utils";

function* downloadSaga(action) {
  try {
    const response = yield call(apiDownload, action);
    JSONToCSVDownload(userCSVFormat(response), "usersList_download.csv");
    yield put(downloadSuccess([...response]));
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

const userCSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    id: json?.id,
    kind: json?.kind,
    version: json?.version,
    versionid: json?.versionid,
    createdon: json?.createdon,
    lastupdated: json?.lastupdated,
    credentialsid: json?.credentialsid ? obscureEmail(json?.credentialsid) : "",
    credentialstype: json?.credentialstype,
    state: json?.state,
    acktermson: json?.acktermson,
    firstname: json?.firstname ? obscureText(json?.firstname, " ") : "",
    lastname: json?.lastname ? obscureText(json?.lastname, " ") : "",
    email: json?.email ? obscureEmail(json?.email) : "",
    mdn: json?.mdn ? obscureText(json?.mdn, " ") : "",
    billingaccountid: json?.billingaccountid,
    requestedon: json?.requestedon,
    orgId: json?.customdata?.orgId,
    roleId: json?.customdata?.roleId,
  }));
};

function apiDownload(action) {
  const { searchName, searchFirstName, searchLastName, searchEmail, roleFilter, organizationFilter, accountName, currentrole } = action.payload;
  const filterBody = {
    accountName,
    currentrole,
    filter: {
      $sort: action.payload.sort,
      $querytotalcount: true,
    },
  };

  const selection = buildSelection({ searchName, searchFirstName, searchLastName, searchEmail, roleFilter, organizationFilter });
  if (selection) {
    filterBody.filter.$selection = selection;
  }
  let activeSession = sessionStorage.getItem("activeSession");
  if (activeSession) {
    activeSession = JSON.parse(activeSession);
  }
  return fetch(fetchUserEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify(filterBody),
  }).then((response) => response.json());
}

function fetchUserAPi() {
  let activeSession = sessionStorage.getItem("activeSession");
  if (activeSession) {
    activeSession = JSON.parse(activeSession);
  }
  return fetch(fetchUserEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      // currentrole: activeSession?.role?.name,
      currentrole: "ORG_ADMIN",
      filter: {
        $sort: [
          {
            field: "firstname",
            order: "asc",
          },
        ],
        $querytotalcount: true,
      },
    }),
  })
    .then((res) => res.json())
    .then((data) =>
      data.map((user) => ({
        key: user?.id,
        name: `${user?.firstname} ${user?.lastname}`,
        email: user?.email,
        role: user?.role || "ORG_ADMIN",
        id: user?.credentialsid,
        phoneNumber: user?.mdn,
      }))
    );
}

function* fetchUserSaga() {
  try {
    const response = yield call(fetchUserAPi);
    yield put(fetchUserSuccess(response));
  } catch (error) {
    yield put(fetchUserError(error.message));
  } finally {
    yield put(setIsLoading(false));
  }
}

function buildSelection({ searchName, searchFirstName, searchLastName, searchEmail, roleFilter, organizationFilter }) {
  let selection = [];
  if (searchName && (Array.isArray(searchName) ? searchName.length > 0 : !!searchName)) {
    const names = Array.isArray(searchName) ? searchName : [searchName];
    const nameConditions = names.map(
      (name) => {
        const firstName = typeof name === "string" ? name.split(" ")[0] : name;
        return `(firstname LIKE '${firstName}')`;
      }
    );
    selection.push(`(${nameConditions.join(" OR ")})`);
  }

  if (searchEmail && (Array.isArray(searchEmail) ? searchEmail.length > 0 : !!searchEmail)) {
    const emails = Array.isArray(searchEmail) ? searchEmail : [searchEmail];
    const emailConditions = emails.map(
      (email) => `(email CONTAINS '${email.toLowerCase()}')`
    );
    selection.push(`(${emailConditions.join(" OR ")})`);
  }

  if (roleFilter && Array.isArray(roleFilter) && roleFilter.length > 0) {
    const roleConditions = roleFilter.map(
      (role) => `($/customdata/roleId = '${role}')`
    );
    selection.push(`(${roleConditions.join(" OR ")})`);
  }

  if (organizationFilter && Array.isArray(organizationFilter) && organizationFilter.length > 0) {
    const orgConditions = organizationFilter.map(
      (org) => `($/customdata/orgName = '${org}')`
    );
    selection.push(`(${orgConditions.join(" OR ")})`);
  }

  return selection.length > 0 ? selection.join(" AND ") : "";
}


function* fetchUsersListSagaApi(action) {
  try {
    const { searchName, searchFirstName, searchLastName, searchEmail, roleFilter, organizationFilter, accountName, currentrole } = action.payload;
    const filterBody = {
      accountName,
      currentrole,
      filter: {
        $sort: action.payload.sort,
        $querytotalcount: true,
      },
    };

    if (action.payload?.limit !== -1) {
      filterBody.filter.$pagenumber = action.payload?.pageNo || 0;
      filterBody.filter.$limitnumber = action.payload?.limit || 50;
    }
    const selection = buildSelection({ searchName, searchFirstName, searchLastName, searchEmail, roleFilter, organizationFilter });
    if (selection) {
      filterBody.filter.$selection = selection;
    }
    const response = yield call(fetch, fetchUserEndPoint(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify(filterBody),
    });

    const data = yield response.json();
    const totalUserCount = Number(response.headers.get("x-total-count")) || 0;
    return response.ok ? { data, totalUserCount } : { data: [], totalUserCount: 0 };
  } catch (error) {
    return [];
  }
}

function* fetchUserListSaga(action) {
  try {
    const result = yield call(fetchUsersListSagaApi, action);
    yield put(fetchUserListSuccess(result.data, result.totalUserCount));
  } catch (error) {
    yield put(fetchUserListError(error.message));
  } finally {
    yield put(setIsLoading(false));
  }
}

function* fetchRolesListSaga() {
  try {
    const data = yield call(fetchRoles);
    yield put(fetchRolesListSuccess(data));
  } catch (error) {
    yield put(fetchRolesListFailure(error));
  }
}


export function* FetchUserSaga() {
  yield takeLatest(userTypes.FETCH_USER, fetchUserSaga);
}

export function* FetchUsersListSaga() {
  yield takeLatest(userTypes.FETCH_USER_LIST, fetchUserListSaga);
}

export function* FetchRolesListSaga() {
  yield takeLatest(userTypes.FETCH_ROLES_REQUEST, fetchRolesListSaga);
}

export function* UsersDownloadSaga() {
  yield takeLatest(userTypes.DOWNLOAD_REQUEST, downloadSaga);
}
